// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HqfW","right":"styles_right__1wT82"};